import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Directive,
  Inject,
  input,
  Optional,
  PLATFORM_ID,
  signal,
  ViewContainerRef,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Icon } from '../components/icon/icon.component';

const Errors = [
  { key: 'required', message: '이 항목은 필수입니다' },
  { key: 'email', message: '이메일 형식이 아닙니다' },
  { key: 'array', message: '이 항목은 필수입니다' },
  { key: 'object-required', message: '이 항목은 필수입니다.' },
];

@Directive({
  selector: '[formError]',
})
export class FormErrorDirective implements AfterViewInit {
  constructor(
    private readonly viewContainerRef: ViewContainerRef,
    private readonly changeRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private readonly platformId: string,
    @Optional() private readonly ngControl: NgControl,
  ) {}

  touched = signal(false);

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.ngControl) {
        const formControl = this.ngControl.control;
        if (formControl) {
          formControl.valueChanges.subscribe({
            next: (ev) => {
              if (ev) {
                this.touched.set(true);
              }

              if (formControl.invalid && this.touched()) {
                const error = Errors.find((error) =>
                  formControl.getError(error.key),
                );

                // 기존 메시지 컴포넌트 제거
                this.viewContainerRef.clear();

                if (error) {
                  const { message } = error;
                  const factory =
                    this.viewContainerRef.createComponent(FormMessage);

                  factory.setInput('message', message);
                  this.viewContainerRef.element.nativeElement.appendChild(
                    factory.location.nativeElement,
                  );
                }
              } else {
                this.viewContainerRef.clear();
              }

              this.changeRef.detectChanges();
            },
          });
        }
      }
    }
  }
}

@Component({
  selector: 'app-form-error',
  template: `
    <div
      class="flex gap-2 items-center px-2 py-1 mt-2 text-xs text-red-400 rounded-md bg-red-50 w-max"
    >
      <app-icon size="xs" name="mdi:close" class="text-red-400" />
      <p>{{ message() }}</p>
    </div>
  `,
  imports: [Icon],
})
class FormMessage {
  message = input.required<string>();
}
